import {
  LOAD_SUCCESS_MENAGES,
  LOAD_FAIL_MENAGES,
  SAVE_SUCCESS_MENAGES,
  SAVE_FAIL_MENAGES,
  UPDATE_SUCCESS_MENAGES,
  UPDATE_FAIL_MENAGES,
  DELETE_SUCCESS_MENAGES,
  DELETE_FAIL_MENAGES,
} from "../actions/menageAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_MENAGES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_MENAGES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_MENAGES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_MENAGES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_MENAGES:
      let updatedListe = [];
      state.data.forEach((item) => {
        if (item.menage_id === action.payload.menage_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_MENAGES:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_MENAGES:
      const filtered = state.data.filter((item) => {
        return item.menage_id !== action.payload.menage_id;
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_MENAGES:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: state.data,
        error: action.payload,
      };
    default:
      return state;
  }
}
